import styled, { css } from 'styled-components'
import { darken } from 'polished'
// import { theme } from 'live/services/theme'

export const LastUpdate = styled.div`
    font-size: 11px;
`

export const Label = styled.div<{ titleFontSize: string; titleBold: boolean }>`
    flex-basis: 50%;
    flex-flow: column;
    justify-content: center;
    font-size: ${props => props.titleFontSize ?? '14'}px;
    font-weight: ${props => (props.titleBold === true ? 'bold' : 'normal')};
    line-height: ${props => (props.titleFontSize ? props.titleFontSize * 0.8 : '14')}px;
    white-space: no-wrap;
    text-overflow: ellipsis;
`

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    margin: 1%;
    flex-flow: column;
    border-left: 8px solid #fff;
    padding: 12px 12px 12px 16px;
    background-color: ${({ theme }) => theme['dash-background']};
    .dark-theme & {
        background-color: rgba(40, 51, 74, 0.5);
        color: #fff;
    }
`

export const Icon = styled.i<{ color: string; bgcolor: string }>`
    cursor: ${props => (props.onClick ? 'pointer' : 'default')};
    position: absolute;
    top: calc(50% - 14px);
    left: -18px;
    width: 28px;
    height: 28px;
    background-color: ${props => props.bgcolor};
    border: 4px solid rgba(230, 230, 230, 0.7);
    border-radius: 100px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: ${props => props.color};

    ${props =>
        props.onClick &&
        css`
            &:hover {
                background-color: ${darken(0.075, props.bgcolor)};
            }
        `}
`

export const Value = styled.div<{ valueFontSize: string; valueBold: boolean }>`
    flex-basis: 50%;
    flex-flow: column;
    justify-content: center;
    white-space: no-wrap;
    font-size: ${props => props.valueFontSize}px;
    font-weight: ${props => (props.valueBold === true ? 'bold' : 'normal')};
`

export const UOM = styled.span<{ uomFontSize: string; uomBold: boolean }>`
    flex-basis: 50%;
    flex-flow: column;
    justify-content: center;

    font-size: ${props => (props.uomFontSize ? props.uomFontSize + 'px' : 0.8 + 'em')};
    font-weight: ${props => (props.uomBold === true ? 'bold' : 'normal')};
`

export const scrollbar = css`
    &::-webkit-scrollbar {
        width: 5px;
        height: 10px;
        -webkit-border-radius: 16px;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: var(--gray-100);
        -webkit-border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: var(--gray-600);
        -webkit-border-radius: 3px;
    }
`

export const StyledGrid = styled.div<{ dark: boolean }>`
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    margin-right: 10px;
    ${scrollbar}
    .grid-widget-container {
        margin: 0 auto;
        box-sizing: border-box;
        padding: 0 0 0 10px;

        .groupTitle {
            color: var(--gray-900);
        }

        .dataLayer {
            display: flex;
            flex-flow: row wrap;
            justify-content: flex-start;
            height: 100%;
            padding: 12px 0 20px;
            margin: 0 -1%;
        }

        .block {
            background-color: rgba(40, 51, 74, 0.5);

            .boxStatus {
                border-color: rgba(40, 51, 74, 0.6);
            }

            .label,
            .value {
                color: var(--gray-900);
            }
        }
    }
`
